import { colors } from '../theme';

export const monitoringStatuses = {
  notMonitoring: { id: 0,  color: colors.orange,title: 'Not Monitoring' },
  monitoring: { id: 1,  color: colors.greenBright,title: 'Monitoring' }
}

export const monitoringStatusList = Object.keys(monitoringStatuses).map(s => ({
  monitoringStatus: s,
  ...monitoringStatuses[s],
}));

export const monitoringStatusBool = {
  notMonitoring: false,
  monitoring: true
}
export const monitoringStatusString = [
  'notMonitoring',
  'monitoring'
]



